import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import ScrollReveal from '../components/ScrollReveal';
import './ProductPage.css';

const CadernosPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <div className="product-page">
        <section className="product-hero">
          <div className="container">
            <div className="hero-grid">
              <ScrollReveal animation="fade-right">
                <div className="hero-text">
                  <h1>Cadernos de Campo Digitais</h1>
                  <p className="hero-description">
                    Digitalize e centralize todos os registos da sua exploração agrícola de forma segura,
                    prática e acessível. Elimine o papel e ganhe eficiência na gestão do seu negócio.
                  </p>
                  <div className="hero-buttons">
                    <a href="/#contact" className="cta-btn primary">
                      Pedir Demonstração
                    </a>
                    <a href="tel:+351969059898" className="cta-btn secondary">
                      Contactar Agora
                    </a>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-left" delay={0.2}>
                <div className="hero-image">
                  <img src="/cadernos.png" alt="Cadernos de Campo Digitais" loading="lazy" />
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-features">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Funcionalidades Principais</h2>
            </ScrollReveal>

            <div className="features-grid">
              <ScrollReveal animation="fade-up" delay={0.1}>
                <div className="feature-card">
                  <div className="feature-icon">📱</div>
                  <h3>Acesso Móvel</h3>
                  <p>Compatível com dispositivos móveis para uso direto no campo, mesmo sem internet.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.2}>
                <div className="feature-card">
                  <div className="feature-icon">🤖</div>
                  <h3>Preenchimento Inteligente</h3>
                  <p>Preenchimento automático e assistido, adaptado ao seu contexto operacional.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.3}>
                <div className="feature-card">
                  <div className="feature-icon">📊</div>
                  <h3>Relatórios Detalhados</h3>
                  <p>Gere relatórios completos para monitorização e melhoria contínua das operações.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.4}>
                <div className="feature-card">
                  <div className="feature-icon">🔒</div>
                  <h3>Segurança Total</h3>
                  <p>Dados armazenados de forma segura com backup automático e encriptação.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.5}>
                <div className="feature-card">
                  <div className="feature-icon">✅</div>
                  <h3>Conformidade Legal</h3>
                  <p>Cumpra todas as obrigações legais de registo de forma simples e automática.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.6}>
                <div className="feature-card">
                  <div className="feature-icon">🌐</div>
                  <h3>Multi-utilizador</h3>
                  <p>Permita que toda a equipa registe atividades com gestão de permissões.</p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-benefits">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Benefícios para o Seu Negócio</h2>
            </ScrollReveal>

            <div className="benefits-list">
              <ScrollReveal animation="fade-right" delay={0.1}>
                <div className="benefit-item">
                  <div className="benefit-number">01</div>
                  <div className="benefit-content">
                    <h3>Maior Precisão nos Dados</h3>
                    <p>Reduza erros de registo manual e garanta a consistência das informações.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.2}>
                <div className="benefit-item">
                  <div className="benefit-number">02</div>
                  <div className="benefit-content">
                    <h3>Poupança de Tempo</h3>
                    <p>Elimine tarefas administrativas repetitivas e foque-se no que realmente importa.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.3}>
                <div className="benefit-item">
                  <div className="benefit-number">03</div>
                  <div className="benefit-content">
                    <h3>Decisões Informadas</h3>
                    <p>Aceda a histórico completo e análises para tomar decisões baseadas em dados.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.4}>
                <div className="benefit-item">
                  <div className="benefit-number">04</div>
                  <div className="benefit-content">
                    <h3>Sustentabilidade</h3>
                    <p>Contribua para o ambiente eliminando o uso de papel na sua exploração.</p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-cta-section">
          <div className="container">
            <ScrollReveal animation="zoom-in">
              <div className="cta-card">
                <h2>Pronto para Digitalizar a Sua Exploração?</h2>
                <p>
                  Junte-se a centenas de agricultores que já confiam nos Cadernos de Campo Digitais
                  da Vulpes para gerir as suas operações com mais eficiência.
                </p>
                <div className="cta-buttons">
                  <a href="/#contact" className="cta-btn primary large">
                    Solicitar Demonstração Gratuita
                  </a>
                  <Link to="/" className="cta-btn secondary large">
                    Voltar ao Início
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default CadernosPage;
